import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};
window.AppointmentBooking.Wizard.Views.Header.MainMenu ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenu.AddressItem = class AddressItem extends (
  AppointmentBooking.Wizard.Views.Header.MainMenu.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.booking, "change:physical_address change:address change:appointment_slot", this.render);
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenu.AddressItem.prototype.template = "header/main_menu/item/address";
AppointmentBooking.Wizard.Views.Header.MainMenu.AddressItem.prototype.className =
  "appointment-booking-wizard-main-menu-address-item";
